import React, { ReactNode, memo } from 'react';
import classNames from 'classnames';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import CustomLink from '../CustomLink/CustomLink';

export enum QuoteFormTabBarTabStatus {
  DEFAULT,
  COMPLETED,
  ACTIVE,
}

interface QuoteFormTabBarTabProps {
  tabNumber: number;
  activeTabNumber: number;
  label: string;
  url?: string;
  theme: Theme;
}

const QuoteFormTabBarTab: React.FC<QuoteFormTabBarTabProps> = ({
  tabNumber,
  activeTabNumber,
  label,
  url,
}) => {
  const TabContainer = (props: {
    url?: string;
    children: ReactNode;
  }): JSX.Element => {
    if (url) {
      return (
        <CustomLink
          url={url}
          label={label}
          className="h-full flex items-center justify-center"
        >
          {props.children}
        </CustomLink>
      );
    } else {
      return (
        <div className="h-full flex items-center justify-center">
          {props.children}
        </div>
      );
    }
  };

  const TabIcon = (props: { tabNumber: number; activeTabNumber: number }) => {
    return (
      <div
        className={classNames(
          'w-[50px] h-8 rounded-full flex items-center justify-center md:w-8',
          {
            'bg-icon/icon-success-bg border border-icon/icon-success-border':
              props.tabNumber < props.activeTabNumber,
            'bg-icon/icon-active-bg border border-icon/icon-active-border text-icon/icon-active-text':
              props.tabNumber === props.activeTabNumber,
            'bg-icon/icon-bg border border-icon/icon-border text-icon/icon-text':
              props.tabNumber > props.activeTabNumber,
          }
        )}
      >
        {props.tabNumber < props.activeTabNumber && (
          <span className="bg-[url('/svgs/white-tick.svg')] w-6 h-6" />
        )}
        {props.tabNumber >= props.activeTabNumber && (
          <>
            <p className="flex items-center justify-center md:hidden">
              <span className="text-system/white pr-1">{props.tabNumber}</span>
              <span className="text-text/body-tint">/ 3</span>
            </p>
            <p className="hidden md:block">{props.tabNumber}</p>
          </>
        )}
      </div>
    );
  };

  return (
    <TabContainer url={url}>
      <div className="flex flex-col items-center space-y-2 font-dm-sans font-bold py-8">
        <TabIcon tabNumber={tabNumber} activeTabNumber={activeTabNumber} />
        <p
          className={classNames({
            'text-text/body': tabNumber === activeTabNumber,
            'text-text/body-tint': tabNumber !== activeTabNumber,
          })}
        >
          {label}
        </p>
      </div>
    </TabContainer>
  );
};

export default memo(withBlokWrapper(QuoteFormTabBarTab));
